<i18n src="./../../i18n/contact_page.json"></i18n>

<template>
    <div id="contact-page">
        <vue-headful
                :title="$t('pageTitle')"
                :description="$t('pageDescription')"
                :url="pageUrl"/>
        <div class="container-fluid">
            <navigation-bar/>

            <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-default-page-header.jpg">
                <div class="container">
                    <p class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;" v-text="$t('contact.title')"/>
                </div>
            </div>

            <div class="container-fluid">
                <div class="container mb-5 mt-5" v-html="content.contactFragment"/>
                <main-map :map-data="content.departmentItems"/>

                <div class="container-fluid mt-contact-section">
                    <div class="lazy container-fluid">
                        <div class="pt-5 pb-5">
                            <div class="pt-5 mt-4 mb-5 text-center">
                                <h2 v-text="$t('contact.header')"/>
                            </div>
                        </div>

                        <contact-form/>

                        <div class="container">
                            <main-footer/>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NavigationBar from "@/components/commons/NavigationBar";
    import MainFooter from "@/components/commons/MainFooter";
    import axios from "axios";
    import {Const} from "@/main";
    import $ from "jquery";
    import ContactForm from "@/components/commons/ContactForm";
    import MainMap from "@/components/commons/MainMap";
    import LazyLoad from "vanilla-lazyload";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "ContactPage",
        components: {MainMap, ContactForm, MainFooter, NavigationBar},
        data () {
            return {
                locale: this.$i18n.locale,
                content: {},
                loaded: false,
                pageUrl: Const.HOST + this.$route.path
            }
        },
        mounted() {
            axios.get(`${Const.API_HOST}/${this.locale}/content/contact`)
                .then(function (response) {
                    return response.data;
                }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(body => {
                this.content = body
                this.loaded = true

                this.$nextTick(() => {
                    lazyLoadInstance.update()
                })
            });

            $(document).scroll(function () {
                var $nav = $(".navbar-light");
                $nav.removeClass('initial');
                $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
            });
        }
    }
</script>

<style scoped>
    .mt-contact-section > .container-fluid {
        background-image: linear-gradient(to top, transparent 0%, transparent 600px, #91A7BD 600px, #91A7BD 606px, #C9D3DE 606px, #C9D3DE 612px, white 612px, white 100%);
    }

    @media (max-width: 768px) {
        .mt-contact-section > .container-fluid {
            background-image: linear-gradient(to top, transparent 0%, transparent 1280px, #91A7BD 1280px, #91A7BD 1286px, #C9D3DE 1286px, #C9D3DE 1292px, white 1292px,  white 100%);
        }
    }

    #paralax-subpage-section {
        height: 200px;
    }
</style>